import { createSelector } from '@ngrx/store';
import { getUXState } from '../reducers';

export const getAppMenuState = createSelector(getUXState, state => state.appMenu);

export const getAppMenuOpened = createSelector(getAppMenuState, state => state.appMenuOpened);
